import { SquaresFour, TrendUp, CurrencyDollar, CreditCard, GearSix, Coins } from '@phosphor-icons/react';
import { SECTIONS, type SectionId } from '../../utils/constants.js';

interface BottomNavProps {
  readonly currentSection: SectionId;
  readonly onNavigate: (s: SectionId) => void;
}

const ICON_MAP: Record<string, typeof SquaresFour> = {
  LayoutDashboard: SquaresFour,
  TrendingUp: TrendUp,
  Coins,
  DollarSign: CurrencyDollar,
  CreditCard,
  Settings: GearSix,
};

export function BottomNav({ currentSection, onNavigate }: BottomNavProps) {
  return (
    <nav class="bottom-nav" aria-label="Главная навигация">
      <div class="bottom-nav-items">
        {SECTIONS.map((section) => {
          const Icon = ICON_MAP[section.icon];
          const isActive = currentSection === section.id;
          return (
            <button
              key={section.id}
              class={`bottom-nav-item${isActive ? ' active' : ''}`}
              onClick={() => onNavigate(section.id)}
              type="button"
              title={section.label}
            >
              {Icon != null && <Icon weight={isActive ? 'fill' : 'regular'} />}
              <span>{section.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
